/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropTwitchClipResponse } from './DropTwitchClipResponse';
import {
    DropTwitchClipResponseFromJSON,
    DropTwitchClipResponseFromJSONTyped,
    DropTwitchClipResponseToJSON,
    DropTwitchClipResponseToJSONTyped,
} from './DropTwitchClipResponse';

/**
 * 
 * @export
 * @interface DropTwitchClipsResponse
 */
export interface DropTwitchClipsResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipsResponse
     */
    channelId: string | null;
    /**
     * 
     * @type {Array<DropTwitchClipResponse>}
     * @memberof DropTwitchClipsResponse
     */
    clips: Array<DropTwitchClipResponse>;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchClipsResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropTwitchClipsResponse interface.
 */
export function instanceOfDropTwitchClipsResponse(value: object): value is DropTwitchClipsResponse {
    if (!('channelId' in value) || value['channelId'] === undefined) return false;
    if (!('clips' in value) || value['clips'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropTwitchClipsResponseFromJSON(json: any): DropTwitchClipsResponse {
    return DropTwitchClipsResponseFromJSONTyped(json, false);
}

export function DropTwitchClipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchClipsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channelId': json['channelId'],
        'clips': ((json['clips'] as Array<any>).map(DropTwitchClipResponseFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropTwitchClipsResponseToJSON(json: any): DropTwitchClipsResponse {
    return DropTwitchClipsResponseToJSONTyped(json, false);
}

export function DropTwitchClipsResponseToJSONTyped(value?: DropTwitchClipsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channelId': value['channelId'],
        'clips': ((value['clips'] as Array<any>).map(DropTwitchClipResponseToJSON)),
        'computedAt': value['computedAt'],
    };
}

